import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Teams from "../../api/team";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/It-Services-Components/Footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/cap.svg";
import bg from "../../images/team/team-bg.jpg";
import WorkSection from "./work";
import Header2 from "../../components/Header2/Header2";

const TeamPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-7 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" />
                      Crafting digital success through code and creativity
                    </span>
                    <h2 className="title">
                      Meet our talented team of SEO experts, web developers,
                      software engineers, app developers, and graphic designers
                      — united by innovation, expertise, and a passion for
                      driving your digital success
                    </h2>
                  </div>
                </div>
                <div className="col-lg-5 mt-30">
                  <div className="count-box">
                    <h2 className="number">
                      02 <span className="suffix">+</span>
                    </h2>
                    <span className="text">
                      Professional Team <br /> Members
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="team pt-55 pb-130">
          <div className="container">
            <div className="row mt-none-30">
              {Teams.map((team, tsm) => (
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30" key={tsm}>
                  <div className="team-item">
                    <div className="xb-item--content pos-rel">
                      <div className="xb-item--img">
                        <img src={bg} alt="" />
                      </div>
                      <div className="xb-item--item">
                        <span className="xb-item--skill">{team.exprience}</span>
                        <span className="xb-item--reating">
                          <i className="fas fa-star"></i> {team.rating}
                        </span>
                      </div>
                    </div>
                    <div className="xb-item--inner ul_li_between align-items-end">
                      <div className="xb-item--holder">
                        <div className="xb-item--avatar">
                          <img src={team.tImg} alt="" />
                        </div>
                        <div className="xb-item--author">
                          <h3 className="xb-item--name">{team.name}</h3>
                          <span className="xb-item--desig">{team.title}</span>
                        </div>
                      </div>
                      <ul className="xb-item--social-link ul_li">
                        <li>
                          <a target="_blank" href={team.li}>
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href={team.ig}>
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <WorkSection />
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TeamPage;
